/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * ImageHideIcon
 */
export default class ImageHideIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M.293.293a1 1 0 011.414 0l11.912 11.91c.032.026.064.054.094.084l.083.094 9.911 9.912a1 1 0 01-1.414 1.414l-2.001-1.999c-.398.19-.838.292-1.292.292H5l-.059-.002h.001L5 22a3 3 0 01-3-3V5.004v.016-.066c-.002-.155-.003-.531.002-.627.014-.278.061-.507.192-.718L.293 1.707a1 1 0 010-1.414zm12.706 14.121L7.414 20h11.171l-5.586-5.586zM4 5.415V19a1 1 0 00.65.937L11.584 13l-2.49-2.49a2.499 2.499 0 01-3.143-3.142L4 5.415zM19 2a3 3 0 013 3v11a1 1 0 01-2 0v-.585l-4.035-4.036a1 1 0 01-1.158-1.6l.486-.486a1 1 0 011.414 0L20 12.585V5a1 1 0 00-1-1H8a1 1 0 110-2h11z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

